export default __webpack_public_path__ + "static/media/search_brand.b34dfd6d.svg";